export default __webpack_public_path__ + "static/media/targetArrow.cf814aef.svg";